import React from "react"
import { useTranslation } from "react-i18next"

import { RoomAirVolumeInput } from "./RoomAirVolumeInput"

export interface RoomExhaustAirInputProps {
  hideLabel?: boolean
  autoFocus?: boolean
}

export const RoomExhaustAirInput = React.memo(
  ({ hideLabel, autoFocus }: RoomExhaustAirInputProps) => {
    const { t } = useTranslation()
    return (
      <RoomAirVolumeInput
        name="room.eta"
        className="room-form__exhaust-air"
        label={t("Room.eta")}
        unit="m³/h"
        color="#f1d100"
        hideLabel={hideLabel}
        autoFocus={autoFocus}
        testId="room__exhaust-air__input"
      />
    )
  }
)
